// extracted by mini-css-extract-plugin
export default {"main":"Error404_main__Ihm4U"};